import Button from '../../../components/base/Button';

export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-amber-50 to-orange-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            聯絡我們
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            歡迎詢問任何關於馬的咖啡的問題
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <div className="bg-white rounded-2xl p-8 shadow-lg mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">聯絡資訊</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-line text-xl text-amber-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">地址</h4>
                    <p className="text-gray-600">南投縣仁愛鄉中正村平等巷95號馬的咖啡</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">電話</h4>
                    <p className="text-gray-600">0923-337087</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-line-fill text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">Line ID</h4>
                    <p className="text-gray-600">6808051979</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                    <i className="ri-time-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">營業時間</h4>
                    <p className="text-gray-600">請來電詢問</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">位置資訊</h3>
              <div className="aspect-video rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.123456789!2d120.123456!3d24.123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDA3JzI0LjQiTiAxMjDCsDA3JzI0LjQiRQ!5e0!3m2!1szh-TW!2stw!4v1234567890123"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="馬的咖啡莊園位置"
                ></iframe>
              </div>
            </div>
          </div>
          
          <div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">聯絡方式</h3>
              <div className="space-y-6">
                <div className="text-center">
                  <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-phone-line text-2xl text-amber-600"></i>
                  </div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">電話聯絡</h4>
                  <p className="text-gray-600 mb-4">歡迎來電詢問咖啡相關問題</p>
                  <Button
                    onClick={() => window.open('tel:0923-337087')}
                    className="whitespace-nowrap"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    撥打電話
                  </Button>
                </div>

                <div className="border-t border-gray-200 pt-6">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-line-fill text-2xl text-green-600"></i>
                    </div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Line 聯絡</h4>
                    <p className="text-gray-600 mb-4">掃描 QR Code 加入好友</p>
                    
                    <div className="bg-white border-2 border-green-100 rounded-xl p-4 inline-block">
                      <img 
                        src="https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/1d2ee60a4f89ac9962c87bf435b07776.jpeg"
                        alt="Line QR Code"
                        className="w-48 h-48 object-contain"
                      />
                      <p className="text-sm text-gray-500 mt-2">Line ID: 6808051979</p>
                    </div>
                  </div>
                </div>
                
                <div className="border-t border-gray-200 pt-6">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-map-pin-line text-2xl text-green-600"></i>
                    </div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">地圖導航</h4>
                    <p className="text-gray-600 mb-4">使用 Google 地圖查看位置</p>
                    <Button
                      onClick={() => window.open('https://maps.app.goo.gl/Ces5Hod8nfQwG2Lc6', '_blank')}
                      variant="outline"
                      className="whitespace-nowrap"
                    >
                      <i className="ri-navigation-line mr-2"></i>
                      開啟地圖
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
